import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ingredientKind: {
    defaultMessage: `{ingredient_kind, select,
        bases {Bases}
        toppings {Toppings}
        premiums {Premiums}
        dressings {Dressings}
        bread {Bread}
        other {{ingredient_kind}}
    }`,
    description: 'Customization | Ingredients grid | Ingredient kinds',
  },
  dressingsHelperText: {
    defaultMessage: 'Portions + details on next step',
    description:
      'Customization | Ingredients grid | Ingredient kinds helper text',
  },
});
